// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCirCopyrightCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PtoCirCopyrightCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoCirCopyrightCircleOutlined = function PtoCirCopyrightCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCirCopyrightCircleOutlinedSvg
  }));
};

PtoCirCopyrightCircleOutlined.displayName = 'PtoCirCopyrightCircleOutlined';
export default React.forwardRef(PtoCirCopyrightCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCirCopyrightCircleOutlined.js
// module id = 3892
// module chunks = 0